import { api } from '@api/api2';

import { SetTmcPayload } from '../../interfaces';

const getTicketTmc = (id: number | null) =>
  api.v4('get', `integration/toir/ticket-specific-data/${id}`);
const setTmc = (payload: SetTmcPayload) =>
  api.v4('post', 'integration/toir/create-act', payload);

const getAvailableTehzor = (id: number | null) =>
  api.v4('get', `integration/tehzor/ticket-info/${id}`);

const sendTicketToTehzor = (id: number) =>
  api.v4('post', `integration/tehzor/send-ticket/${id}`);

export const ticketTmcApi = {
  getTicketTmc,
  setTmc,
  getAvailableTehzor,
  sendTicketToTehzor
};
